import { CREATE_NOTICE_FAILURE, CREATE_NOTICE_SUCCESS, GET_NOTICE_LIST_FAILURE, GET_NOTICE_LIST_SUCCESS } from "./notice.actionTypes";

const initialState = {
  notice: null,
};

export default function createNoticeTeacherReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case GET_NOTICE_LIST_SUCCESS:
      return {
        ...state,
        notice: payload,
      };
    case GET_NOTICE_LIST_FAILURE:
      return {
        ...state,
        message: "",
      };


    default:
      return state;
  }
}
